import React, {useEffect, useState} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SumsubWebSdk from '@sumsub/websdk-react';
import { toast } from 'react-toastify';
import '../styles/MainSection.css';
import backIcon from "../assets/back.png";
import {getKycAccessToken} from '../requests/requests';
import { getDataStorage } from '../helpers/storage';

function KycConfirmVerification() {

  const navigate = useNavigate();
  const [kycaAcessToken, setKycaAcessToken] = useState("");
  const [loggedUser, setLoggedUser] = useState({});
  const [kycaAcessTokenLoading, setKycaAcessTokenLoading] = useState(false);

  const intFunc = async () => {
    setKycaAcessTokenLoading(true);
    const user      = await getDataStorage("loggedUser", false, true);
    const userToken = await getDataStorage("authToken", false, false);
    setLoggedUser(user);
    const accessTokenDetails = await getKycAccessToken({email: user?.email, authToken: userToken});
    setKycaAcessTokenLoading(false);
    if(accessTokenDetails.status === false || accessTokenDetails.status === 'error'){
      return toast.error(accessTokenDetails?.message);
    } else {
      setKycaAcessToken(accessTokenDetails?.application_token);
    }
  }

  useEffect(() => {
    intFunc();
  }, [])
  
  const onMessage = (message) => {
    console.log('Sumsub message   ------ : ', message);
  };

  const onError = (error) => {
    console.error('Sumsub error  -------: ', error);
  };

  const refreshToken = async () => {

  }

  const handleTokenExpiration = async (refresh) => {
    const newToken = await refreshToken();
    refresh(newToken); 
  };

  return (
    <div className="App  kyc-verify-block">
      {/* <Header /> */}
       <div>
        <div className="close-back clearfix group">
          <div className="close-back-icon"  onClick={() => navigate('/profile')}>
            <img src={backIcon} alt="back" /> 
            <p>Back to profile</p>
          </div>
        </div>
        {!kycaAcessTokenLoading ? (
          <SumsubWebSdk
            accessToken={kycaAcessToken}
            expirationHandler={handleTokenExpiration}
            onMessage={(message) => console.log("Message:", message)}
            onError={(error) => console.error("Error:", error)}
            options={{ 
                       lang: 'en',
                       country: 'uga',
                       email: loggedUser?.email,
                       phone: '',
                       theme: 'light',
                       controlledNavigationBack: true
                     }} />
        ) : (
           <div className="loading-blocking">
              <p >Loading verification...</p>
            </div>
        )}
        
       </div>
    </div>
  );
}


export default KycConfirmVerification;
